import classnames from 'classnames';
import * as React from 'react';

// @ts-expect-error
import type {FormProps} from 'redux-form/lib/types.js.flow';

import {Button} from 'shells/button/button';
import {ErrorMessage} from 'shells/form/error-message';
import {Subheader} from 'shells/typography/subheader';

import {Field, reduxForm} from 'redux-form';

import {FORGOT_PASSWORD_REDUX_FORM} from '../../constants';
import {TinyIntroTextField} from '../../fields/tiny-intro-text-field';

import styles from './forgot-password-form.module.css';

type OwnProps = {
    successMessage: string | null | undefined;
};

type Props = OwnProps & FormProps;

function validate(values: any) {
    const errors: Record<string, any> = {};

    if (!values.username || !values.username.trim()) {
        errors.username = 'Please enter an email address';
    }

    return errors;
}

export function ForgotPasswordFormComponent(props: Props) {
    React.useEffect(() => {
        props.destroy();
        props.initialize(props.initialValues);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <form onSubmit={props.handleSubmit}>
            <Subheader>
                Enter your email address and we’ll send a link to reset your password.
            </Subheader>
            <div className={styles.fields}>
                <Field
                    key='email'
                    name='username'
                    placeholder='john.appleseed@nutshell.com'
                    title='Email'
                    type='email'
                    autoFocus={true}
                    disabled={props.submitSucceeded}
                    component={TinyIntroTextField}
                    variant='redux-form'
                />
            </div>
            {props.successMessage ? (
                <div className={styles.success}>{props.successMessage}</div>
            ) : (
                <div className={classnames(styles.button, styles.submit)}>
                    <Button
                        // @ts-expect-error
                        disabled={props.submitting}
                        type='submit'
                        size='xlarge'
                        isFullWidth={true}
                    >
                        Reset password
                    </Button>
                </div>
            )}
            {props.submitFailed ? <ErrorMessage>{props.error}</ErrorMessage> : null}
        </form>
    );
}

export const ForgotPasswordForm = reduxForm({
    form: FORGOT_PASSWORD_REDUX_FORM,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    validate,
})(ForgotPasswordFormComponent);
